import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactLoading from 'react-loading';
import { primarycolor } from "../Utils/colors";
import { Savehousedetailsurl, Singlehouseurl, Uploadprofileurl, Uploadslotimageurl } from "./../Utils/urls";
import styles from './../Hostels/houses.module.css';
import styless from './style.module.css';
import { FaFacebookMessenger, FaStarOfLife, FaStar, FaTrash, FaHandHoldingWater, FaChalkboard, FaBath, FaLaptopHouse, FaBoxTissue, FaShower, FaWifi, FaToriiGate, FaChair, FaChessBoard, FaBed, FaMapMarkerAlt, FaPhoneAlt, FaEdit, FaSave, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { setsessionhouse, getsessionuser } from "../Utils/sessions";
import Universalheader from "../Headers/universalheader";


let color = primarycolor;
let typee = "spokes";


const Viewsingleproperty = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const id = location.pathname.split("/")[3];
    const sessionuser = getsessionuser();
    const [maindiv, setmaindiv] = useState(true);
    const [house, sethouse] = useState('');
    const [progress, setprogress] = useState(true);
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');
    const [display, setdisplay] = useState(false);
    const [facilities, setfacilities] = useState('');
    const [edit, setedit] = useState(false);
    const [defaulturl, setdefaulturl] = useState('');

    //photos div
    const [editprofile, seteditprofile] = useState(false);
    const [editimage1, seteditimage1] = useState(false);
    const [editimage2, seteditimage2] = useState(false);
    const [editimage3, seteditimage3] = useState(false);
    const [editimage4, seteditimage4] = useState(false);

    //house details
    const [hotshower, sethotshower] = useState('');
    const [dustbin, setdustbin] = useState('');
    const [kitchensink, setkitchensink] = useState('');
    const [bathroom, setbathroom] = useState('');
    const [balcony, setbalcony] = useState('');
    const [ceiling, setceiling] = useState('');
    const [toilet, settoilet] = useState('');
    const [bed, setbed] = useState('');
    const [router, setrouter] = useState('');
    const [gate, setgate] = useState('');
    const [chair, setchair] = useState('');
    const [tiles, settiles] = useState('');
    const [matress, setmatress] = useState('');
    const [unread, setunread] = useState('');

    //other details
    const [type, settype] = useState('');
    const [payments, setpayments] = useState('');
    const [avalrooms, setavalrooms] = useState('');
    const [trooms, settrooms] = useState('');
    const [price, setprice] = useState('');
    const [housename, sethousename] = useState('');
    const [email, setemail] = useState('');
    const [phone, setphone] = useState('');

    //pictures
    const [profilepic_url, setprofilepic_url] = useState('');
    const [profilepic, setprofilepic] = useState('');

    const [image1, setimage1] = useState('');
    const [image1url, setimage1url] = useState('');

    const [image2, setimage2] = useState('');
    const [image2url, setimage2url] = useState('');

    const [image3, setimage3] = useState('');
    const [image3url, setimage3url] = useState('');

    const [image4, setimage4] = useState('');
    const [image4url, setimage4url] = useState('');

    const [slot, setslot] = useState('');




    useEffect(() => {
        gethouse();
    }, []);

    const gethouse = () => {
        setdisplay(false)
        seterror(null)
        axios.post(Singlehouseurl, {
            id: id
        }).then(response => {
            setprogress(false)
            if (!response.data.message) {
                response.data[0].facilities[0].hotshower === 'hotshower' && sethotshower(true)
                response.data[0].facilities[0].dustbin === 'dustbin' && setdustbin(true)
                response.data[0].facilities[0].kitchensink === 'kitchensink' && setkitchensink(true)
                response.data[0].facilities[0].bathroom === 'bathroom' && setbathroom(true)
                response.data[0].facilities[0].balcony === 'balcony' && setbalcony(true)
                response.data[0].facilities[0].ceiling === 'ceiling' && setceiling(true)
                response.data[0].facilities[0].toilet === 'toilet' && settoilet(true)
                response.data[0].facilities[0].bed === 'bed' && setbed(true)
                response.data[0].facilities[0].gate === 'gate' && setgate(true)
                response.data[0].facilities[0].router === 'router' && setrouter(true);
                response.data[0].facilities[0].chair === 'chair' && setchair(true)
                response.data[0].facilities[0].tiles === 'tiles' && settiles(true)
                response.data[0].facilities[0].matress === 'matress' && setmatress(true)
                setdisplay(true)
                sethouse(response.data[0])
                setemail(response.data[0].email)
                sethousename(response.data[0].housename)
                setphone(response.data[0].phone)
                setdefaulturl(response.data[0].profilepic_url)
                setfacilities(response.data[0].facilities[0])
                settrooms(response.data[0].totalrooms)
                setavalrooms(response.data[0].availablerooms)
                settype(response.data[0].type)
                setpayments(response.data[0].payments)
                setprice(response.data[0].price)
                setprofilepic_url(response.data[0].profilepic_url)
                setimage1url(response.data[0].pic1_url)
                setimage2url(response.data[0].pic2_url)
                setimage3url(response.data[0].pic3_url)
                setimage4url(response.data[0].pic4_url)
            } else {
                setdisplay(false)
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setprogress(false)
            seterror("Sorry there was an error try again later")

        });
    }

    //start chat
    const startchat = () => {
        setsessionhouse(house)
        navigate("/nav/chats", {
            state: { message: "startchart" }
        })
    }

    //save house details
    const Onsave = () => {
        setsuccess("")
        seterror(null)
        if (!trooms || !type || !price) {
            setprogress(false)
            seterror("Fill all fields")
        } else {
            setprogress(true)
            axios.post(Savehousedetailsurl, {
                id: id,
                email: email,
                phone: phone,
                housename: housename,
                trooms: trooms,
                avalrooms: avalrooms,
                price: price,
                type: type,
                payments: payments,
                facilities: [{
                    dustbin: dustbin ? "dustbin" : null,
                    kitchensink: kitchensink ? "kitchensink" : null,
                    bathroom: bathroom ? "bathroom" : null,
                    balcony: balcony ? "balcony" : null,
                    ceiling: ceiling ? "ceiling" : null,
                    toilet: toilet ? "toilet" : null,
                    bed: bed ? "bed" : null,
                    hotshower: hotshower ? "hotshower" : null,
                    router: router ? "router" : null,
                    gate: gate ? "gate" : null,
                    chair: chair ? "chair" : null,
                    tiles: tiles ? "tiles" : null,
                    matress: matress ? "matress" : null
                }
                ]

            }).then(response => {
                setprogress(false)
                if (!response.data.message) {
                    setsuccess(response.data.success)
                    setTimeout(() => {
                        setedit(false);
                        setprogress(true);
                        gethouse();
                        setsuccess("")
                    }, 2000);
                } else {
                    setprogress(false)
                    seterror(response.data.message)
                }

            }).catch(error => {
                setprogress(false)
                seterror("Sorry there was an error try again later")
            });
        }
    }

    //uploadprofile image
    const onupload = () => {
        setprogress(true)
        seterror(null)
        setsuccess("")
        const formData = new FormData();
        formData.append(
            "file",
            profilepic,
            profilepic.name
        );

        if (profilepic.name) {
            setprogress(true)
            axios.post(Uploadprofileurl + id, formData).
                then(response => {
                    setprogress(false)
                    if (!response.data.message) {
                        if (response.data.success) {
                            setsuccess(response.data.success)
                            gethouse()
                            seteditprofile(false)
                            seteditimage1(false)
                            seteditimage2(false)
                            seteditimage3(false)
                            seteditimage4(false)
                            setTimeout(() => {
                                setsuccess("")
                            }, 3000);
                        } else {
                            seterror("there was an internal error contact admin")
                        }
                    } else {
                        seterror(response.data.message);
                        setprogress(false)
                    }
                    // 
                }).catch(error => {
                    seterror("Sorry an error occurred,try again later");
                    setprogress(false)
                });
        } else {
            seterror("Image to be uploaded is empty")
            setprogress(false)
        }
    }


    //uploadslot image
    const onuploadslot = () => {
        setprogress(true)
        seterror(null)
        setsuccess("")
        if (!image1 && !image2 && !image3 && !image4) {
            seterror("Select an image to upload")
            setprogress(false)
        } else {


            const formData = new FormData();

            slot === 'slot1' && formData.append(
                "file",
                image1,
                image1.name,

            );

            slot === 'slot2' && formData.append(
                "file",
                image2,
                image2.name,

            );

            slot === 'slot3' && formData.append(
                "file",
                image3,
                image3.name,

            );

            slot === 'slot4' && formData.append(
                "file",
                image4,
                image4.name,

            );

            axios.post(Uploadslotimageurl + "&slot=" + slot + "&id=" + id, formData).
                then(response => {
                    setprogress(false)
                    if (!response.data.message) {
                        if (response.data.success) {
                            setsuccess(response.data.success)
                            gethouse()
                            seteditprofile(false)
                            seteditimage1(false)
                            seteditimage2(false)
                            seteditimage3(false)
                            seteditimage4(false)
                            setTimeout(() => {
                                setsuccess("")
                            }, 3000);
                        } else {
                            seterror("there was an internal error contact admin")
                        }
                    } else {
                        seterror(response.data.message);
                        setprogress(false)
                    }
                    // 
                }).catch(error => {
                    seterror("Sorry an error occurred,try again later");
                    setprogress(false)
                });

        }
    }




    const Stars = ({ rating }) => {

        if (rating > 4) {
            return <div>
                <FaStar color="#ff9334" /><FaStar color="#ff9334" /><FaStar color="#ff9334" /><FaStar color="#ff9334" /><FaStar color="#ff9334" />
            </div>
        }
        if (rating > 3.9 && rating < 5) {
            return <div>
                <FaStar color="#ff9334" /><FaStar color="#ff9334" /><FaStar color="#ff9334" /><FaStar color="#ff9334" /><FaStar color="gray" />
            </div>
        }
        if (rating > 2.9 && rating < 4) {
            return <div>
                <FaStar color="#ff9334" /><FaStar color="#ff9334" /><FaStar color="#ff9334" /><FaStar color="gray" /><FaStar color="gray" />
            </div>
        }
        if (rating > 1.9 && rating < 3) {
            return <div>
                <FaStar color="#ff9334" /><FaStar color="#ff9334" /><FaStar color="gray" /><FaStar color="gray" /><FaStar color="gray" />
            </div>
        }
        if (rating > 0.9 && rating < 2) {
            return <div>
                <FaStar color="#ff9334" /><FaStar color="gray" /><FaStar color="gray" /><FaStar color="gray" /><FaStar color="gray" />
            </div>
        }
        if (rating < 0.9) {
            return <div>
                <FaStar color="gray" /><FaStar color="gray" /><FaStar color="gray" /><FaStar color="gray" /><FaStar color="gray" />
            </div>
        }
    }






    return (
        <div className={styles.container}>
            <div className={styles.topheader} style={{ paddingBottom: 100 }}>
                <Universalheader />
                <div className={styles.advertisediv}>
                    <FaStarOfLife color={primarycolor} size={15} />
                    <Link to="">
                        <a href="https://play.google.com/store/apps/details?id=com.eazistey.eazistey">List on Eazistey</a>
                    </Link>
                </div>
                <div className={styles.housenamediv}>
                    {error && <div style={{ color: "red" }}><FaExclamationCircle color="red" />{error}</div>}
                    {success && <div style={{ color: "green" }}><FaCheckCircle color={"green"} />{success}</div>}
                    {edit ? <div className={styless.editbutton} onClick={Onsave}>
                        <FaSave size={20} />
                    </div> : <div className={styless.editbutton} onClick={() => setedit(!edit)}>
                        <FaEdit size={20} />
                    </div>}
                    {edit ?
                        <input type="text" value={housename} onChange={(e) => sethousename(e.target.value)} className={styless.detailsinput} /> :
                        <div className={styles.housenamehead}>{house.housename?.toUpperCase()}</div>}

                </div>
                <div className={styles.linksdiv}>
                    <Link to="/">
                        <a>Home  /</a>
                    </Link>

                    <a onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>myhostels  /</a>

                    <Link to="">
                        <a>{house.housename}  /</a>
                    </Link>
                    {!maindiv && <a onClick={() => { setmaindiv(true) }} style={{ cursor: "pointer" }}>back  /</a>}

                </div>
                <div className={styles.bodydiv}>

                    <div className={styles.housedetailsdiv}>
                        {maindiv ? <div>
                            <div className={styles.profileanddetailsdiv}>

                                {progress ? <div className={styles.mainphoto}>
                                    <ReactLoading type={typee} color={color} height={20} width={20} className={styles.loaderimage} />
                                </div> : <div>
                                    {edit && <button className={styless.editphotobutton} onClick={() => setmaindiv(false)}>Edit photos</button>}
                                    <img src={defaulturl} className={styles.mainphoto} /></div>}
                                <div className={styles.rightdivhouse}>
                                    <div className={styles.facilitiesdiv}>
                                        {progress ?
                                            <div className={styles.unloadeddetails}>
                                            </div> :
                                            <div className={styles.detailsdiv}>
                                                <div className={styles.amenitieshead}>Details</div>
                                                {edit ? <input type="text" value={type} onChange={(e) => settype(e.target.value)} className={styless.detailsinput} /> : house.type}<br />
                                                Available rooms:  {edit ? <input type="text" value={avalrooms} onChange={(e) => setavalrooms(e.target.value)} className={styless.detailsinputsmall} /> : house.availablerooms} <br />
                                                Location: {house.location} <br />
                                                Rent:  {edit ? <input type="text" value={price} onChange={(e) => setprice(e.target.value)} className={styless.detailsinputsmall} /> : house.price} per month <br />
                                                Phone Number:  {edit ? <input type="text" value={phone} onChange={(e) => setphone(e.target.value)} className={styless.detailsinput} /> : house.phone} <br />
                                                Email:  {edit ? <input type="text" value={email} onChange={(e) => setemail(e.target.value)} className={styless.detailsinput} /> : house.email}

                                            </div>}
                                    </div>
                                </div>
                            </div>


                            {progress ? <div style={{ display: "flex" }}>
                                <ReactLoading type={typee} color={color} height={20} width={20} className={styles.loaderslotimage} />
                                <ReactLoading type={typee} color={color} height={20} width={20} className={styles.loaderslotimage} />
                                <ReactLoading type={typee} color={color} height={20} width={20} className={styles.loaderslotimage} />
                                <ReactLoading type={typee} color={color} height={20} width={20} className={styles.loaderslotimage} />
                            </div> :
                                <div style={{ display: "flex" }}>
                                    <img src={house.pic1_url} onClick={() => setdefaulturl(house.pic1_url)} className={styles.slotimages} />
                                    <img src={house.pic2_url} onClick={() => setdefaulturl(house.pic2_url)} className={styles.slotimages} />
                                    <img src={house.pic3_url} onClick={() => setdefaulturl(house.pic3_url)} className={styles.slotimages} />
                                    <img src={house.pic4_url} onClick={() => setdefaulturl(house.pic4_url)} className={styles.slotimages} />
                                    {defaulturl !== house.profilepic_url && <img src={house.profilepic_url} onClick={() => setdefaulturl(house.profilepic_url)} className={styles.slotimages} />}
                                </div>}
                            {progress ?
                                <div className={styles.unloadedamenities}>

                                </div> :
                                <div className={styles.amenitiesdiv} style={{ backgroundColor: "white" }}>
                                    <div className={styles.amenitieshead}>Amenities</div>

                                    {edit ? <div className={styles.alldivfacilities}>

                                        {dustbin ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => setdustbin(!dustbin)}>
                                            <FaTrash />&nbsp;
                                            Dustbin
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => setdustbin(!dustbin)}>
                                            <FaTrash />&nbsp;
                                            Dustbin
                                        </div>}
                                        {kitchensink ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => setkitchensink(!kitchensink)}>
                                            <FaHandHoldingWater />&nbsp;
                                            Kitchensink
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => setkitchensink(!kitchensink)}>
                                            <FaHandHoldingWater />&nbsp;
                                            Kitchensink
                                        </div>}
                                        {bathroom ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => setbathroom(!bathroom)}>
                                            <FaBath />&nbsp;
                                            Bathroom
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => setbathroom(!bathroom)}>
                                            <FaBath />&nbsp;
                                            Bathroom
                                        </div>}
                                        {balcony ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => setbalcony(!balcony)}>
                                            <FaLaptopHouse />&nbsp;
                                            Balcony
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => setbalcony(!balcony)}>
                                            <FaLaptopHouse />&nbsp;
                                            Balcony
                                        </div>}
                                        {ceiling ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => setceiling(!ceiling)}>
                                            <FaChalkboard />&nbsp;
                                            Ceiling
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => setceiling(!ceiling)}>
                                            <FaChalkboard />&nbsp;
                                            Ceiling
                                        </div>}
                                        {toilet ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => settoilet(!toilet)}>
                                            <FaBoxTissue />&nbsp;
                                            Toilet
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => settoilet(!toilet)}>
                                            <FaBoxTissue />&nbsp;
                                            Toilet
                                        </div>}
                                        {hotshower ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => sethotshower(!hotshower)}>
                                            <FaShower />&nbsp;
                                            Hotshower
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => sethotshower(!hotshower)}>
                                            <FaShower />&nbsp;
                                            Hotshower
                                        </div>}
                                        {router ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => setrouter(!router)}>
                                            <FaWifi />&nbsp;
                                            Router
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => setrouter(!router)}>
                                            <FaWifi />&nbsp;
                                            Router
                                        </div>}
                                        {gate ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => setgate(!gate)}>
                                            <FaToriiGate />&nbsp;
                                            Gate
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => setgate(!gate)}>
                                            <FaToriiGate />&nbsp;
                                            Gate
                                        </div>}
                                        {chair ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => setchair(!chair)}>
                                            <FaChair />&nbsp;
                                            Chair
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => setchair(!chair)}>
                                            <FaChair />&nbsp;
                                            Chair
                                        </div>}
                                        {tiles ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => settiles(!tiles)}>
                                            <FaChessBoard />&nbsp;
                                            Tiles
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => settiles(!tiles)}>
                                            <FaChessBoard />&nbsp;
                                            Tiles
                                        </div>}
                                        {matress ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => setmatress(!matress)}>
                                            <FaBed />&nbsp;
                                            Matress
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => setmatress(!matress)}>
                                            <FaBed />&nbsp;
                                            Matress
                                        </div>}
                                        {bed ? <div className={styles.faciliydiv2} style={{ cursor: "pointer" }} onClick={() => setbed(!bed)}>
                                            <FaBed />&nbsp;
                                            Bed
                                        </div> : <div className={styles.faciliydiv} style={{ cursor: "pointer" }} onClick={() => setbed(!bed)}>
                                            <FaBed />&nbsp;
                                            Bed
                                        </div>}
                                    </div>

                                        : <div className={styles.alldivfacilities}>
                                            {facilities.dustbin !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaTrash />&nbsp;
                                                    Dustbin
                                                </div>}
                                            {facilities.kitchensink !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaHandHoldingWater />&nbsp;
                                                    Kitchensink
                                                </div>}
                                            {facilities.bathroom !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaBath />&nbsp;
                                                    Bathroom
                                                </div>}
                                            {facilities.balcony !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaLaptopHouse />&nbsp;
                                                    Balcony
                                                </div>}
                                            {facilities.ceiling !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaChalkboard />&nbsp;
                                                    Ceiling
                                                </div>}
                                            {facilities.toilet !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaBoxTissue />&nbsp;
                                                    Toilet
                                                </div>}
                                            {facilities.hotshower !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaShower />&nbsp;
                                                    Hotshower
                                                </div>}
                                            {facilities.router !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaWifi />&nbsp;
                                                    Router
                                                </div>}
                                            {facilities.gate !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaToriiGate />&nbsp;
                                                    Gate
                                                </div>}
                                            {facilities.chair !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaChair />&nbsp;
                                                    Chair
                                                </div>}
                                            {facilities.tiles !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaChessBoard />&nbsp;
                                                    Tiles
                                                </div>}
                                            {facilities.matress !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaBed />&nbsp;
                                                    Matress
                                                </div>}
                                            {facilities.bed !== null &&
                                                <div className={styles.faciliydiv}>
                                                    <FaBed />&nbsp;
                                                    Bed
                                                </div>}

                                        </div>}
                                    <div className={styles.amenitieshead}>Other payments</div>
                                    <div>{edit ? <input type="text" value={payments} onChange={(e) => setpayments(e.target.value)} className={styless.detailsinput} /> : house.payments}</div>
                                    <div className={styles.amenitieshead}>Location</div>
                                    <div>{house.location} &nbsp;&nbsp;Near {house.landmark}</div>
                                    <a href={`https://maps.eazistey.co.ke/?longitude=${house.longitude}&latitude=${house.latitude}`}><button className={styles.mapbutton}
                                    ><FaMapMarkerAlt color={primarycolor} /> View on Map</button></a>
                                </div>}


                            <div className={styles.amenitieshead}>Contact Details</div>
                            {progress ?
                                <div className={styles.unloadedcontacts}>

                                </div> :
                                <div className={styles.contactdetails}>
                                    <div className={styles.callmessagediv}>
                                        <button onClick={() => navigate("tel:" + house.phone)} className={styles.callbutton}><FaPhoneAlt /> Call the Caretaker</button>
                                        <button className={styles.chatbutton} onClick={startchat}><FaFacebookMessenger /> Chat</button>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                        <img src={house.ownerurl} />
                                        <p style={{ marginLeft: 10 }}>
                                            <div style={{ fontWeight: "bold", fontSize: 15 }}>{house.username}</div>
                                            <div style={{ fontSize: 10 }}>Property Caretaker<br /></div>
                                        </p>
                                    </div>

                                </div>}
                        </div> :
                            <div><div style={{ fontSize: 13, color: "red" }}>{error}</div>
                                {progress && <ReactLoading type={typee} color={color} height={20} width={20} />}
                                <div>
                                    <div className={styless.slotimagediv}> <img src={house.profilepic_url} className={styles.slotimages} /><br />
                                        {editprofile ? <div> <input type="file" onChange={e => setprofilepic(e.target.files[0])} />
                                            <button onClick={onupload}>upload</button></div> : <button onClick={() => {
                                                seteditprofile(true)
                                                seteditimage1(false)
                                                seteditimage2(false)
                                                seteditimage3(false)
                                                seteditimage4(false)
                                            }}>Edit</button>}
                                    </div>
                                    <div className={styless.slotimagediv}><img src={house.pic1_url} className={styles.slotimages} /><br />
                                        {editimage1 ? <div> <input type="file" onChange={e => {
                                            setslot("slot1")
                                            setimage1(e.target.files[0])
                                        }} />
                                            <button onClick={onuploadslot}>upload</button></div> : <button onClick={() => {
                                                seteditprofile(false)
                                                seteditimage1(true)
                                                seteditimage2(false)
                                                seteditimage3(false)
                                                seteditimage4(false)
                                            }}>Edit</button>}
                                    </div>
                                    <div className={styless.slotimagediv}><img src={house.pic2_url} className={styles.slotimages} /><br />
                                        {editimage2 ? <div> <input type="file" onChange={e => {
                                            setslot("slot2")
                                            setimage2(e.target.files[0])
                                        }} />
                                            <button onClick={onuploadslot}>upload</button></div> : <button onClick={() => {
                                                seteditprofile(false)
                                                seteditimage1(false)
                                                seteditimage2(true)
                                                seteditimage3(false)
                                                seteditimage4(false)
                                            }}>Edit</button>}
                                    </div>
                                    <div className={styless.slotimagediv}><img src={house.pic3_url} className={styles.slotimages} /><br />
                                        {editimage3 ? <div> <input type="file" onChange={e => {
                                            setslot("slot3")
                                            setimage3(e.target.files[0])
                                        }} />
                                            <button onClick={onuploadslot}>upload</button></div> : <button onClick={() => {
                                                seteditprofile(false)
                                                seteditimage1(false)
                                                seteditimage2(false)
                                                seteditimage3(true)
                                                seteditimage4(false)
                                            }}>Edit</button>}
                                    </div>
                                    <div className={styless.slotimagediv}> <img src={house.pic4_url} className={styles.slotimages} /><br />
                                        {editimage4 ? <div > <input type="file" onChange={e => {
                                            setslot("slot4")
                                            setimage4(e.target.files[0])
                                        }} />
                                            <button onClick={onuploadslot}>upload</button></div> : <button onClick={() => {
                                                seteditprofile(false)
                                                seteditimage1(false)
                                                seteditimage2(false)
                                                seteditimage3(false)
                                                seteditimage4(true)
                                            }}>Edit</button>}
                                    </div>
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Viewsingleproperty;